module.exports = __webpack_public_path__ + "media/images/setting-70b9b11ac4d6bd6512b6fe31419187f3.svg";